import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center flex-wrap gap-1.5 text-sm">
        <li>
          <Link
            to="/"
            className="text-foreground-500 hover:text-primary-400 transition-colors"
          >
            <i className="ri-home-4-line"></i>
          </Link>
        </li>
        {items.map((item, idx) => {
          const category = categories.find((c) => c.slug === item.href?.replace('/category/', ''));
          return (
            <li key={idx} className="flex items-center gap-1.5">
              <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {category ? (
                    <>
                      <i className={`${category.icon} mr-1`}></i>
                      {item.label}
                    </>
                  ) : (
                    item.label
                  )}
                </Link>
              ) : (
                <span className="text-primary-400 whitespace-nowrap">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}